import { render, staticRenderFns } from "./NotificationsTag.vue?vue&type=template&id=645b7a2a&scoped=true&lang=pug"
import script from "./NotificationsTag.vue?vue&type=script&lang=ts"
export * from "./NotificationsTag.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsTag.vue?vue&type=style&index=0&id=645b7a2a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b7a2a",
  null
  
)

export default component.exports